






























import { defineComponent, ref, watch, computed } from '@vue/composition-api';
import dayjs from 'dayjs';
import { toLocaleString, toISOString } from '@/containers/globals/Util';
import { millisecondsToSeconds } from '@/utils/AnnouncementUtils';
import { newPortalDate } from '@/utils/PortalDate';

interface Props {
  value: number | null;
  language: string;
}

export default defineComponent({
  props: {
    value: {
      type: Number,
      required: false,
      default: null,
    },
    label: {
      type: String,
      required: true,
    },
    rules: {
      type: Array,
      required: false,
    },
    language: {
      type: String,
      required: false,
      default: 'ja',
    },
  },

  setup(props: Props, { emit }) {
    const menu = ref(false);
    const ISOString = ref(toISOString(props.value));
    const localeString = ref(toLocaleString(props.value));
    const initialDate = ref();

    const toISOStringFunc = () => {
      ISOString.value = toISOString(localeString.value);
      localeString.value = toLocaleString(ISOString.value);
      emit(
        'input',
        ISOString.value
          ? millisecondsToSeconds(Date.parse(ISOString.value))
          : null
      );
    };

    const locale = computed(() =>
      props.language === 'ja' ? 'ja-JP' : 'en-US'
    );

    watch(
      () => props.value,
      value => {
        // set current date to the datepicker
        if (initialDate.value) {
          initialDate.value.tableDate = newPortalDate(
            dayjs(),
            'YYYY-MM'
          ).toString();
        }
        ISOString.value = toISOString(value);
      }
    );

    watch(ISOString, value => {
      localeString.value = toLocaleString(value);
      emit(
        'input',
        value ? millisecondsToSeconds(Date.parse(ISOString.value)) : null
      );
    });

    const onInput = () => {
      menu.value = false;
    };

    return {
      ISOString,
      menu,
      onInput,
      localeString,
      locale,
      toISOStringFunc,
      initialDate,
    };
  },
});
